var hideClass = 'hidden',
    Beanstalk = {

		init: function () {

			Beanstalk.tooltips();
			Beanstalk.helpDropdown();
		},

		tooltips: function () {
			var selector = 'abbr[title], *[rel=tooltip]';

			$('.tooltip').remove();

			if ($(selector).length) {
				$(selector).tooltips();
			}
		},

		helpDropdown: function () {
			$('.link-help').on('mouseenter', function () {
				$('#support').showMe();
			});

			$('#support').on('mouseleave', function () {
				$('#support').hideMe();
			});
		},
	};


$(document).ready(Beanstalk.init);


/* Extensions */

jQuery.fn.extend({

	showMe: function () {
		return this.removeClass(hideClass);
	},

	hideMe: function () {
		return this.addClass(hideClass);
	},

	toggleMe: function () {
		return this.toggleClass(hideClass);
	},

	isHidden: function () {
		if (this.hasClass(hideClass)) {
			return true;
		} else {
			return false;
		}
	}

});


// Add forEach method to old browsers

if (!Array.prototype.forEach) {
	Array.prototype.forEach = function(fn, scope) {
		for (var i = 0, len = this.length; i < len; ++i) {
			fn.call(scope || this, this[i], i, this);
		}
	};
}


// Highlight current Features nav item

const featuresNav = document.querySelector('#feature-head nav');
if (featuresNav) {
  const pathname = window.location.pathname;

  featuresNav.querySelectorAll('li').forEach(item => {
    const link = item.querySelector('a');
    if (!link) { return; }

    const href = link.getAttribute('href');
    if (href === pathname) {
      item.classList.add('current');
    }
  });
}

const primaryNav = document.querySelector('#primary');
if (primaryNav) {
  const pathname = window.location.pathname;

  primaryNav.querySelectorAll('li').forEach(item => {
    const link = item.querySelector('a');
    if (!link) { return; }

    const href = link.getAttribute('href');
    if (href === pathname) {
      item.classList.add('current');
    }
    if (href === '/version-control.html' && (pathname === '/deployments.html' || pathname === '/integration.html' || pathname === '/collaboration.html' || pathname === '/security.html')) {
      item.classList.add('current');
    }
  });
}
